<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="totalStock" >
        <span slot="label" >
          <a-tooltip>
            扣减总量<template slot="title">扣减总量</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.totalStock" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入扣减总量" />
      </a-form-model-item>
<!--      <a-form-model-item prop="intervalTime" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品自动扣减库存脚本.时间间隔')}}<template slot="title">{{$t('商品自动扣减库存脚本.时间间隔')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.intervalTime"  placeholder="请输入$t('商品自动扣减库存脚本.时间间隔')" />
      </a-form-model-item>-->
      <a-form-model-item prop="limitStock" >
        <span slot="label" >
          <a-tooltip>
            单次扣减上限<template slot="title">单次扣减上限</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.limitStock" oninput="value=value.replace(/[^\d]/g,'')"  placeholder="请输入单次扣减上限" />
      </a-form-model-item>
      <a-form-model-item prop="highStock" >
        <span slot="label" >
          <a-tooltip>
            高频数字<template slot="title">高频数字,逗号分割</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.highStock"  placeholder="请输入高频数字" />
      </a-form-model-item>
      <a-form-model-item prop="startTime" >
        <span slot="label" >
          <a-tooltip>
            开始时间<template slot="title">开始时间</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.startTime" valueFormat='YYYY-MM-DD HH:mm:ss' show-time allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="endTime" >
        <span slot="label" >
          <a-tooltip>
            结束时间<template slot="title">结束时间</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.endTime" valueFormat='YYYY-MM-DD HH:mm:ss' show-time allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="deductedStock" >
        <span slot="label" >
          <a-tooltip>
            已扣减量<template slot="title">已扣减量</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.deductedStock"  disabled placeholder="请输入已扣减总量" />
      </a-form-model-item>
      <a-form-model-item prop="status" >
        <span slot="label" >
          <a-tooltip>
            是否启用<template slot="title">是否启用</template>
          </a-tooltip>
        </span>
        <a-radio-group v-model="form.status" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getStockScriptByGoodsId, addStockScript, updateStockScript } from '@/api/goods/stockScript'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,
        goodsId: null,
        type: 2,
        totalStock: 1,
        intervalTime: null,
        limitStock: 1,
        highStock:null,
        startTime: null,
        endTime: null,
        deductedStock: 1,
        status: true,
        createTime: null,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        totalStock: [
          { required: true, message: '扣减总量不能为空', trigger: 'blur' }
        ],
        limitStock: [
          { required: true, message: '单次扣减上限不能为空', trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: '开始时间不能为空', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '结束时间不能为空', trigger: 'change' }
        ],
        status: [
          { required: true, message: '状态不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        goodsId: null,
        type: 2,
        totalStock: 1,
        intervalTime: null,
        limitStock: 1,
        highStock:null,
        startTime: null,
        endTime: null,
        deductedStock: 0,
        status: true,
        createTime: null,
        remark: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (goodsId) {
      if (goodsId === null) {
        this.$message.error('Please Select Products')
        return
      }
      this.reset();
      this.formType = 2
      getStockScriptByGoodsId({"id":goodsId}).then(response => {
        if (response.data === null) {
          this.reset()
          this.form.goodsId=goodsId
        } else {
          this.form = response.data
        }
        console.log('this.form', this.form)
        this.open = true;
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          message = this.$t('修改成功')
          updateStockScript(this.form).then(response => {
            this.$message.success(
              message,
              3
            )
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
